<template>
    <div id="paypalPayment">
        <select v-model="paymentId" class="form-control mb-2">
            <template v-for="order in orders">
                <option :value="order.id">{{order.label}}</option>
            </template>
        </select>
        <div v-if="isPaypalButton">
          <div  ref="paypal"></div>
          <div  ref="creditCard"></div>
        </div>
        <div class="text-center" v-else>
            <span class="pb-1" style="color: red;">{{$t('paypalpayment.errorePulsante')}}</span>
            <button type="button" class="btn btn-block cursorNotAllowed" style="background: #0070ba!important;" disabled>
                <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAxcHgiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAxMDEgMzIiIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaW5ZTWluIG1lZXQiIHhtbG5zPSJodHRwOiYjeDJGOyYjeDJGO3d3dy53My5vcmcmI3gyRjsyMDAwJiN4MkY7c3ZnIj48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNIDEyLjIzNyAyLjggTCA0LjQzNyAyLjggQyAzLjkzNyAyLjggMy40MzcgMy4yIDMuMzM3IDMuNyBMIDAuMjM3IDIzLjcgQyAwLjEzNyAyNC4xIDAuNDM3IDI0LjQgMC44MzcgMjQuNCBMIDQuNTM3IDI0LjQgQyA1LjAzNyAyNC40IDUuNTM3IDI0IDUuNjM3IDIzLjUgTCA2LjQzNyAxOC4xIEMgNi41MzcgMTcuNiA2LjkzNyAxNy4yIDcuNTM3IDE3LjIgTCAxMC4wMzcgMTcuMiBDIDE1LjEzNyAxNy4yIDE4LjEzNyAxNC43IDE4LjkzNyA5LjggQyAxOS4yMzcgNy43IDE4LjkzNyA2IDE3LjkzNyA0LjggQyAxNi44MzcgMy41IDE0LjgzNyAyLjggMTIuMjM3IDIuOCBaIE0gMTMuMTM3IDEwLjEgQyAxMi43MzcgMTIuOSAxMC41MzcgMTIuOSA4LjUzNyAxMi45IEwgNy4zMzcgMTIuOSBMIDguMTM3IDcuNyBDIDguMTM3IDcuNCA4LjQzNyA3LjIgOC43MzcgNy4yIEwgOS4yMzcgNy4yIEMgMTAuNjM3IDcuMiAxMS45MzcgNy4yIDEyLjYzNyA4IEMgMTMuMTM3IDguNCAxMy4zMzcgOS4xIDEzLjEzNyAxMC4xIFoiPjwvcGF0aD48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNIDM1LjQzNyAxMCBMIDMxLjczNyAxMCBDIDMxLjQzNyAxMCAzMS4xMzcgMTAuMiAzMS4xMzcgMTAuNSBMIDMwLjkzNyAxMS41IEwgMzAuNjM3IDExLjEgQyAyOS44MzcgOS45IDI4LjAzNyA5LjUgMjYuMjM3IDkuNSBDIDIyLjEzNyA5LjUgMTguNjM3IDEyLjYgMTcuOTM3IDE3IEMgMTcuNTM3IDE5LjIgMTguMDM3IDIxLjMgMTkuMzM3IDIyLjcgQyAyMC40MzcgMjQgMjIuMTM3IDI0LjYgMjQuMDM3IDI0LjYgQyAyNy4zMzcgMjQuNiAyOS4yMzcgMjIuNSAyOS4yMzcgMjIuNSBMIDI5LjAzNyAyMy41IEMgMjguOTM3IDIzLjkgMjkuMjM3IDI0LjMgMjkuNjM3IDI0LjMgTCAzMy4wMzcgMjQuMyBDIDMzLjUzNyAyNC4zIDM0LjAzNyAyMy45IDM0LjEzNyAyMy40IEwgMzYuMTM3IDEwLjYgQyAzNi4yMzcgMTAuNCAzNS44MzcgMTAgMzUuNDM3IDEwIFogTSAzMC4zMzcgMTcuMiBDIDI5LjkzNyAxOS4zIDI4LjMzNyAyMC44IDI2LjEzNyAyMC44IEMgMjUuMDM3IDIwLjggMjQuMjM3IDIwLjUgMjMuNjM3IDE5LjggQyAyMy4wMzcgMTkuMSAyMi44MzcgMTguMiAyMy4wMzcgMTcuMiBDIDIzLjMzNyAxNS4xIDI1LjEzNyAxMy42IDI3LjIzNyAxMy42IEMgMjguMzM3IDEzLjYgMjkuMTM3IDE0IDI5LjczNyAxNC42IEMgMzAuMjM3IDE1LjMgMzAuNDM3IDE2LjIgMzAuMzM3IDE3LjIgWiI+PC9wYXRoPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0gNTUuMzM3IDEwIEwgNTEuNjM3IDEwIEMgNTEuMjM3IDEwIDUwLjkzNyAxMC4yIDUwLjczNyAxMC41IEwgNDUuNTM3IDE4LjEgTCA0My4zMzcgMTAuOCBDIDQzLjIzNyAxMC4zIDQyLjczNyAxMCA0Mi4zMzcgMTAgTCAzOC42MzcgMTAgQyAzOC4yMzcgMTAgMzcuODM3IDEwLjQgMzguMDM3IDEwLjkgTCA0Mi4xMzcgMjMgTCAzOC4yMzcgMjguNCBDIDM3LjkzNyAyOC44IDM4LjIzNyAyOS40IDM4LjczNyAyOS40IEwgNDIuNDM3IDI5LjQgQyA0Mi44MzcgMjkuNCA0My4xMzcgMjkuMiA0My4zMzcgMjguOSBMIDU1LjgzNyAxMC45IEMgNTYuMTM3IDEwLjYgNTUuODM3IDEwIDU1LjMzNyAxMCBaIj48L3BhdGg+PHBhdGggZmlsbD0iI2ZmZmZmZiIgZD0iTSA2Ny43MzcgMi44IEwgNTkuOTM3IDIuOCBDIDU5LjQzNyAyLjggNTguOTM3IDMuMiA1OC44MzcgMy43IEwgNTUuNzM3IDIzLjYgQyA1NS42MzcgMjQgNTUuOTM3IDI0LjMgNTYuMzM3IDI0LjMgTCA2MC4zMzcgMjQuMyBDIDYwLjczNyAyNC4zIDYxLjAzNyAyNCA2MS4wMzcgMjMuNyBMIDYxLjkzNyAxOCBDIDYyLjAzNyAxNy41IDYyLjQzNyAxNy4xIDYzLjAzNyAxNy4xIEwgNjUuNTM3IDE3LjEgQyA3MC42MzcgMTcuMSA3My42MzcgMTQuNiA3NC40MzcgOS43IEMgNzQuNzM3IDcuNiA3NC40MzcgNS45IDczLjQzNyA0LjcgQyA3Mi4yMzcgMy41IDcwLjMzNyAyLjggNjcuNzM3IDIuOCBaIE0gNjguNjM3IDEwLjEgQyA2OC4yMzcgMTIuOSA2Ni4wMzcgMTIuOSA2NC4wMzcgMTIuOSBMIDYyLjgzNyAxMi45IEwgNjMuNjM3IDcuNyBDIDYzLjYzNyA3LjQgNjMuOTM3IDcuMiA2NC4yMzcgNy4yIEwgNjQuNzM3IDcuMiBDIDY2LjEzNyA3LjIgNjcuNDM3IDcuMiA2OC4xMzcgOCBDIDY4LjYzNyA4LjQgNjguNzM3IDkuMSA2OC42MzcgMTAuMSBaIj48L3BhdGg+PHBhdGggZmlsbD0iI2ZmZmZmZiIgZD0iTSA5MC45MzcgMTAgTCA4Ny4yMzcgMTAgQyA4Ni45MzcgMTAgODYuNjM3IDEwLjIgODYuNjM3IDEwLjUgTCA4Ni40MzcgMTEuNSBMIDg2LjEzNyAxMS4xIEMgODUuMzM3IDkuOSA4My41MzcgOS41IDgxLjczNyA5LjUgQyA3Ny42MzcgOS41IDc0LjEzNyAxMi42IDczLjQzNyAxNyBDIDczLjAzNyAxOS4yIDczLjUzNyAyMS4zIDc0LjgzNyAyMi43IEMgNzUuOTM3IDI0IDc3LjYzNyAyNC42IDc5LjUzNyAyNC42IEMgODIuODM3IDI0LjYgODQuNzM3IDIyLjUgODQuNzM3IDIyLjUgTCA4NC41MzcgMjMuNSBDIDg0LjQzNyAyMy45IDg0LjczNyAyNC4zIDg1LjEzNyAyNC4zIEwgODguNTM3IDI0LjMgQyA4OS4wMzcgMjQuMyA4OS41MzcgMjMuOSA4OS42MzcgMjMuNCBMIDkxLjYzNyAxMC42IEMgOTEuNjM3IDEwLjQgOTEuMzM3IDEwIDkwLjkzNyAxMCBaIE0gODUuNzM3IDE3LjIgQyA4NS4zMzcgMTkuMyA4My43MzcgMjAuOCA4MS41MzcgMjAuOCBDIDgwLjQzNyAyMC44IDc5LjYzNyAyMC41IDc5LjAzNyAxOS44IEMgNzguNDM3IDE5LjEgNzguMjM3IDE4LjIgNzguNDM3IDE3LjIgQyA3OC43MzcgMTUuMSA4MC41MzcgMTMuNiA4Mi42MzcgMTMuNiBDIDgzLjczNyAxMy42IDg0LjUzNyAxNCA4NS4xMzcgMTQuNiBDIDg1LjczNyAxNS4zIDg1LjkzNyAxNi4yIDg1LjczNyAxNy4yIFoiPjwvcGF0aD48cGF0aCBmaWxsPSIjZmZmZmZmIiBkPSJNIDk1LjMzNyAzLjMgTCA5Mi4xMzcgMjMuNiBDIDkyLjAzNyAyNCA5Mi4zMzcgMjQuMyA5Mi43MzcgMjQuMyBMIDk1LjkzNyAyNC4zIEMgOTYuNDM3IDI0LjMgOTYuOTM3IDIzLjkgOTcuMDM3IDIzLjQgTCAxMDAuMjM3IDMuNSBDIDEwMC4zMzcgMy4xIDEwMC4wMzcgMi44IDk5LjYzNyAyLjggTCA5Ni4wMzcgMi44IEMgOTUuNjM3IDIuOCA5NS40MzcgMyA5NS4zMzcgMy4zIFoiPjwvcGF0aD48L3N2Zz4=" data-v-188c8269="" alt="" aria-label="PayPal" class="paypal-logo paypal-logo-paypal paypal-logo-color-white" style="width: 70px!important;">
            </button>
        </div>
    </div>
</template>

<script>
import 'bootstrap'
import $ from 'jquery'
import {paymentsType} from "@/helpers/utilities";
import Swal from "sweetalert2";
import _ from 'lodash'
import RuntimeConfig from "@/helpers/RuntimeConfig";
import WrappedWorker from "@/lib/ConcorsandoWasm/WrappedWorker";
import {mapActions, mapGetters} from "vuex";
import {MODULES} from "@/store/modules-enum";
import {AUTH_GETTERS} from "@/store/auth/getters-enum";
import {PROFILE_ACTIONS} from "@/store/profile/actions-enum";
import firebase from "firebase/app";
import BrevoClient from "../lib/CustomConcorsandoClient/api/BrevoClient";


const brevoClient = BrevoClient.instance
export default {
    name: "PayPalPayment",
    data () {
        return {
            paymentId: paymentsType[0].id,
            orders: paymentsType,
            isPaypalButton: true,
        }
    },
    computed: {
        ...mapGetters(MODULES.AUTH, [AUTH_GETTERS.PROFILE])
    },
    mounted: function() {
        if (window.paypal === undefined) {
            const script = document.createElement("script");
            const clientId = RuntimeConfig.instance.paypalClientId || "";
            if (!RuntimeConfig.instance.paypalClientId) {
                console.error("Error: ClientId is not defined");
            }
            script.src = `https://www.paypal.com/sdk/js?client-id=${clientId}&currency=EUR`;
            script.addEventListener("load", () => this.setLoaded(script));
            script.addEventListener('error', () => this.handlePaypalError(script));
            document.body.appendChild(script);
        }
        else {
            this.setLoaded();
        }
    },
    methods: {
        ...mapActions(MODULES.PROFILE, [PROFILE_ACTIONS.GET_USER]),
        async getPaypalCustomId() {
            let user_id = String(this.profile.id_utente_concorsando);
            let hmac = await WrappedWorker.instance.getHash(user_id);
            return JSON.stringify({id: user_id, codice: String(hmac)});
        },
        setLoaded(script) {
            if (window.paypal === undefined) {
                this.handlePaypalError(script);
                return;
            }
            window.paypal
                .Buttons({
                    fundingSource: window.paypal.FUNDING.PAYPAL,
                    style: {
                        shape: 'rect',
                        color: 'blue',
                        layout: 'vertical',
                        label: 'paypal',
                    },
                    createOrder: (data, actions) => {
                        const paymentType = _.find(paymentsType, {id: this.paymentId})
                        if (!paymentType) {
                          return Promise.reject(new Error("Value not found"))
                        }
                        return this.getPaypalCustomId().then(custom_id => actions.order.create({
                            purchase_units: [{
                                // reference_id: "reference_id",
                                custom_id, // -> custom
                                description: `Versione Premium ${paymentType.item_name}`, // -> transaction_subject
                                amount: {
                                    currency_code: 'EUR',
                                    value: paymentType.value,
                                    breakdown: {
                                        item_total: {
                                            currency_code: 'EUR',
                                            value: paymentType.value,
                                        },
                                    }
                                },
                                items: [{ // -> txn_type: cart
                                    name: paymentType.item_name, // -> item_name1
                                    unit_amount: {
                                        currency_code: 'EUR',
                                        value: paymentType.value,
                                    },
                                    quantity: 1,
                                    description: paymentType.item_name,
                                    sku: paymentType.item_number // -> item_number1
                                }]
                            }]
                        }));
                    },
                    onApprove: (data, actions) => {
                        $('.loading').show()
                        return actions.order.capture()
                        .then((details) => {
                            $('.loading').hide()
                            if(details.purchase_units && details.purchase_units.length > 0){
                                const purchase_unit = details.purchase_units[0];
                                if(purchase_unit.items && purchase_unit.items.length > 0){
                                    const item = purchase_unit.items[0]
                                    const name = item.name;
                                    const amount = item.unit_amount?.value
                                    const currency_code = item.unit_amount?.currency_code;
                                    firebase.analytics().logEvent('web_purchase', {name: name, amount: amount, currency_code: currency_code})
                                     window.fbq('trackCustom', 'web_purchase', {name: name, amount: amount, currency_code: currency_code})
                                }
                            }
                            try {
                              Swal.fire({
                                title: 'Ben fatto!',
                                text: 'Transazione avvenuta con successo',
                                icon: 'success',
                                confirmButtonText: this.$t('generale.ok'),
                                showLoaderOnConfirm: true,
                                preConfirm: () => {
                                    return this.getUser().then((user) => {
                                        const livello = user && user.livello;
                                        this.contacts(user)
                                        if (livello !== 1) {
                                            throw new Error("Not premium");
                                        }
                                    })
                                    .catch(() => {
                                        setTimeout(() => {
                                            // Mostra errore
                                            Swal.fire({
                                                title: 'Attenzione!',
                                                text: this.$t('profile.modale.errore.aggiornamentoPremiumInCorso'),
                                                icon: 'error',
                                                confirmButtonText: this.$t('generale.ok')
                                            })
                                        }, 200);
                                    })
                                    .then(() => undefined)
                                }
                              })
                            } catch (e) {
                              console.error(e)
                            }
                        })
                        .catch(() => {
                            Swal.fire({
                                title: 'Attenzione!',
                                text: 'Si è verificato un errore con l\'ordine effettuato con PayPal',
                                icon: 'error',
                                confirmButtonText: this.$t('generale.ok')
                            })
                        })
                    },
                    onError: err => {
                        $('.loading').hide()
                        Swal.fire({
                            title: 'Attenzione!',
                            text: 'Transazione non avvenuta',
                            icon: 'error',
                            confirmButtonText: this.$t('generale.ok')
                        })
                    },
                    onCancel: () => {
                      $('.loading').hide()
                    }
                })
                .render(this.$refs.paypal);

          window.paypal
              .Buttons({
                fundingSource: window.paypal.FUNDING.CARD,
                createOrder: (data, actions) => {
                  const paymentType = _.find(paymentsType, {id: this.paymentId})
                  if (!paymentType) {
                    return Promise.reject(new Error("Value not found"))
                  }
                  return this.getPaypalCustomId().then(custom_id => actions.order.create({
                    purchase_units: [{
                      // reference_id: "reference_id",
                      custom_id, // -> custom
                      description: `Versione Premium ${paymentType.item_name}`, // -> transaction_subject
                      amount: {
                        currency_code: 'EUR',
                        value: paymentType.value,
                        breakdown: {
                          item_total: {
                            currency_code: 'EUR',
                            value: paymentType.value,
                          },
                        }
                      },
                      items: [{ // -> txn_type: cart
                        name: paymentType.item_name, // -> item_name1
                        unit_amount: {
                          currency_code: 'EUR',
                          value: paymentType.value,
                        },
                        quantity: 1,
                        description: paymentType.item_name,
                        sku: paymentType.item_number // -> item_number1
                      }]
                    }],
                    card: {
                      attributes: {
                        verification: {
                          method: "SCA_ALWAYS"
                        },
                      },
                    },
                  }));
                },
                onApprove: (data, actions) => {
                  $('.loading').show()
                  return actions.order.capture()
                      .then((details) => {
                        $('.loading').hide()
                        if(details.purchase_units && details.purchase_units.length > 0){
                          const purchase_unit = details.purchase_units[0];
                          if(purchase_unit.items && purchase_unit.items.length > 0){
                            const item = purchase_unit.items[0]
                            const name = item.name;
                            const amount = item.unit_amount?.value
                            const currency_code = item.unit_amount?.currency_code;
                            firebase.analytics().logEvent('web_purchase', {name: name, amount: amount, currency_code: currency_code})
                            window.fbq('trackCustom', 'web_purchase', {name: name, amount: amount, currency_code: currency_code})
                          }
                        }
                        try {
                          Swal.fire({
                            title: 'Ben fatto!',
                            text: 'Transazione avvenuta con successo',
                            icon: 'success',
                            confirmButtonText: this.$t('generale.ok'),
                            showLoaderOnConfirm: true,
                            preConfirm: () => {
                              return this.getUser().then((user) => {
                                const livello = user && user.livello;
                                this.contacts(user)
                                if (livello !== 1) {
                                  throw new Error("Not premium");
                                }
                              })
                                  .catch(() => {
                                    setTimeout(() => {
                                      // Mostra errore
                                      Swal.fire({
                                        title: 'Attenzione!',
                                        text: this.$t('profile.modale.errore.aggiornamentoPremiumInCorso'),
                                        icon: 'error',
                                        confirmButtonText: this.$t('generale.ok')
                                      })
                                    }, 200);
                                  })
                                  .then(() => undefined)
                            }
                          })
                        } catch (e) {
                          console.error(e)
                        }
                      })
                      .catch(() => {
                        Swal.fire({
                          title: 'Attenzione!',
                          text: 'Si è verificato un errore con l\'ordine effettuato con PayPal',
                          icon: 'error',
                          confirmButtonText: this.$t('generale.ok')
                        })
                      })
                },
                onError: err => {
                  $('.loading').hide()
                  Swal.fire({
                    title: 'Attenzione!',
                    text: 'Transazione non avvenuta',
                    icon: 'error',
                    confirmButtonText: this.$t('generale.ok')
                  })
                },
                onCancel: () => {
                  $('.loading').hide()
                }
              })
              .render(this.$refs.creditCard);
        },
        handlePaypalError(script) {
            this.isPaypalButton = false;
            if (script) {
                document.body.removeChild(script);
            }
        },
        contacts(user) {
            brevoClient.postContacts({
                ext_id: user.id_utente_concorsando?.toString(),
                premium: this.isPremium(user),
                email: user.email_comunicazioni,
            }).then(() => {
                console.log('success')
            })
                .catch(() => {
                    console.log('error')
                })
        },
        isPremium(user) {
            return _.get(user, "livello") <= 1;
        },
    }
}
</script>
